import React, { useState } from 'react';
import './TopBar.css';
import notification from '../../assets/logo/bell.png';
import user from '../../assets/logo/user.png';
import customercart from '../../assets/logo/customerscart.png';
import selfcart from '../../assets/logo/selfcart.png';
import wardcart from '../../assets/logo/wardcart.png';
// import Notification from '../Notification/NotificationSidebar';
// import NotificationSidebarDistributors from '../Notification/NotificationSidebarDistributors';
// import NotificationWards from '../Notification/NotificationWards';
import CartSidebar from '../CartSidebar/CartSidebar'; 
import SelfCart from '../SelfCart/SelfCart';
import WardCart from '../WardsCart/WardCart';
import NotificationSidebar from '../Notification/NotificationSidebar';

const TopBar = ({ role }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCartSidebarOpen, setIsCartSidebarOpen] = useState(false);
  const [isSelfCartSidebarOpen, setIsSelfCartSidebarOpen] = useState(false); 
  const [isWardCartSidebarOpen, setIsWardCartSidebarOpen] = useState(false); 

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleCartSidebar = () => {
    setIsCartSidebarOpen(!isCartSidebarOpen);
  };

  const toggleSelfCartSidebar = () => {
    setIsSelfCartSidebarOpen(!isSelfCartSidebarOpen);
  };

  const toggleWardCartSidebar = () => {
    setIsWardCartSidebarOpen(!isWardCartSidebarOpen);
  };

  const renderProfileTitle = () => {
    switch (role) {
      case 'pharmacist':
        return 'Pharmacy Profile';
      case 'distributor':
        return 'Distributors Profile';
      case 'ward':
        return 'Ward Profile';
      default:
        return 'Profile';
    }
  };

  // const renderNotificationSidebar = () => {
  //   switch (role) {
  //     case 'pharmacist':
  //       return <Notification />;
  //     case 'distributor':
  //       return <NotificationSidebarDistributors />;
  //     case 'ward':
  //       return <NotificationWards />;
  //     default:
  //       return null;
  //   }
  // };

  const renderCartIcons = () => {
    if (role === 'pharmacist') {
      return (
        <>
          <div className="cart-icon-con" onClick={toggleCartSidebar}>
            <img src={customercart} alt="Customer Cart" className="cart-icon" />
          </div>
          <div className="cart-icon-con" onClick={toggleSelfCartSidebar}>
            <img src={selfcart} alt="Self Add to Cart" className="cart-icon" />
          </div>
          <div className="cart-icon-con" onClick={toggleWardCartSidebar}>
            <img src={wardcart} alt="Ward Add to Cart" className="cart-icon" />
          </div>
        </>
      );
    } else if (role === 'ward') {
      return (
        <>
          <div className="cart-icon-con" onClick={toggleCartSidebar}>
            <img src={customercart} alt="Add to cart" className="cart-icon" />
          </div>
        </>
      );
    } else {
      return null;
    }
  };

  return (
    <div className="top-bar">
      <div className="left-section">
        <div className="noti-icon-con" onClick={toggleSidebar}>
          <img src={notification} alt="Notification" className="noti-icon" />
        </div>

        {renderCartIcons()}
      </div>

      <div className="center-section">
        <span className="profile-title">{renderProfileTitle()}</span>
      </div>

      <div className="right-section">
        <div className="user-info">
          <div className="user-icon">
            <img src={user} alt="User" />
          </div>
          <span className="username">{"Arin Jain"}</span>
        </div>
      </div>

      <div
        className={`close-sidebar ${isSidebarOpen ? 'open' : ''}`}
        onClick={() => setIsSidebarOpen(false)}
      >
        &times;
      </div>

      <div className={`notification-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        {/* {renderNotificationSidebar()} */}
        <NotificationSidebar role={role}/>
      </div>

      <WardCart
        isOpen={isWardCartSidebarOpen} 
        closeSidebar={toggleWardCartSidebar} 
      />

      <CartSidebar 
        isOpen={isCartSidebarOpen} 
        closeSidebar={toggleCartSidebar} 
      />

      <SelfCart 
        isOpen={isSelfCartSidebarOpen} 
        closeSidebar={toggleSelfCartSidebar} 
      />
    </div>
  );
};

export default TopBar;
